const breakpoints = {
  values: { xs: 499, sm: 600, md: 900, lg: 1395, xl: 1680 },
};

export default breakpoints;
